import { IGetRowsParams, GridApi } from 'ag-grid-community';
import { lastValueFrom } from 'rxjs';
import { AgGridDataSourceBase, AgGridDataSourceResult } from '../../../Compliance/AgGrid';
import { DataHubLogRepository } from '../dataHubLog.repository';

export class DataHubLogListAgGridDataSource extends AgGridDataSourceBase<void> {
    constructor(
        readonly gridApi: GridApi,
        private readonly _dataHubLogRepository: DataHubLogRepository
    ) {
        super(gridApi);
    }

    private readonly _propertyMap: Compliance.NameValuePair<Core.DataHubSummaryLogPropertyEnum>[] = [
        { name: 'dataHubSummaryLogId', value: Core.DataHubSummaryLogPropertyEnum.DataHubSummaryLogId },
        { name: 'operationType', value: Core.DataHubSummaryLogPropertyEnum.OperationType },
        { name: 'startTime', value: Core.DataHubSummaryLogPropertyEnum.StartTime },
        { name: 'endTime', value: Core.DataHubSummaryLogPropertyEnum.EndTime },
        { name: 'paymentBatchId', value: Core.DataHubSummaryLogPropertyEnum.PaymentBatchId },
        { name: 'packageNumber', value: Core.DataHubSummaryLogPropertyEnum.PackageNumber },
        { name: 'requestPayloadJson', value: Core.DataHubSummaryLogPropertyEnum.RequestPayloadJson },
        { name: 'responsePayloadJson', value: Core.DataHubSummaryLogPropertyEnum.ResponsePayloadJson }
    ];

    protected canGetRows(): boolean {
        return true;
    }

    protected async getRowsInternal(params: IGetRowsParams): Promise<AgGridDataSourceResult> {
        const searchParams: Core.DataHubSummaryLogSearchModel = {
            pagination: {
                skip: params.startRow,
                take: params.endRow - params.startRow
            },
            columnFilters: this.getColumnFilters(this._propertyMap),
            sortColumns: this.getSortColumns(this._propertyMap)
        };

        const result = await lastValueFrom(this._dataHubLogRepository.getList(searchParams));

        return {
            rows: result.data,
            totalRows: result.totalRows
        } as AgGridDataSourceResult;
    }
}
